import { fromJS } from 'immutable/dist/immutable';
import { isString } from '../../../../../form/formUtilities';

export const volcanoEventSearchModel = fromJS({
  name: 'volcanoEventSearchForm',
  initialValues: {
    id: '',
    minId: '',
    maxId: '',
    minYear: '',
    maxYear: '',
    country: '',
    region: '',
    minLongitude: '',
    maxLongitude: '',
    minLatitude: '',
    maxLatitude: '',
    volcanoNames: '',
    morphology: '',
    minVei: '',
    maxVei: '',
    minDeaths: '',
    maxDeaths: '',
    minDeathsAmountOrder: '',
    maxDeathsAmountOrder: '',
    minDamageMillionsDollars: '',
    maxDamageMillionsDollars: '',
    minDamageAmountOrder: '',
    maxDamageAmountOrder: '',
    assocEq: '',
    assocTsu: '',
    nameMatch: '',
    year: '',
    locId: '',
    locPreviousNum: '',
    locNum: '',
    eruption: '',

    radios: {
      locationSearchType: 'locInclude',
      loc: '',
      nameSearchType: 'nameInclude',
      name: '',
      commentsSearchType: 'commentsInclude',
      comments: '',
      expanded: true,
    },

  },
});

export const toSearchParameters = (model) => {
  const search = model.toJS();
  const {
    radios: {
      nameSearchType,
      name,
      locationSearchType,
      loc,
      commentsSearchType,
      comments,
    },
  } = search;

  if (nameSearchType) {
    search[nameSearchType] = name;
  }

  if (locationSearchType) {
    search[locationSearchType] = loc;
  }

  if (commentsSearchType) {
    search[commentsSearchType] = comments;
  }

  delete search.radios;


  Object.keys(search).forEach((key) => {
    let value = search[key];
    if (isString(value)) {
      value = value.trim();
      if (value) {
        search[key] = value;
      } else {
        delete search[key];
      }
    }
  });

  return search;
};
